import { competencyAPI } from '@/providers/apis/competency/competency';
import { DomainModel } from '@/models/proficiency/domain';

export default ({
    namespaced: true,

    state: {
        competencyMatrix: [],
        coordiante: [],
    },
    mutations: {
        fetchUserDomainCompetencyMatrix(state: any, competencyMatrix: DomainModel[]) {
            state.competencyMatrix = competencyMatrix;
        },
        getCompetencyMatrixCoordinates(state: any, coordiante: DomainModel[]) {
            state.coordiante = coordiante;
        },
    },

    actions: {
        async fetchUserDomainCompetencyMatrix(context: any, params: any) {
            return await competencyAPI.fetchUserDomainCompetencyMatrix(params).then((competencyMatrix) => {
                context.commit('fetchUserDomainCompetencyMatrix', competencyMatrix);
                return Promise.resolve();
            });
        },
        async getCompetencyMatrixCoordinates(context: any, params: any) {
            return await competencyAPI.getCompetencyMatrixCoordinates(params).then((coordiante) => {
                context.commit('getCompetencyMatrixCoordinates', coordiante);
                return Promise.resolve();
            });
        },
    },
});
